module.exports = __webpack_public_path__ + "static/media/bfile-kids.d4718819.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-kids.svg
// module id = 3119
// module chunks = 0